import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";
import { GlobalContext } from "../../App";
import Loader from "../../components/Loader/Loader";
import MountCategories from "../../components/MountCategories/MountCategories";
import MountListView, {
  Mount,
} from "../../components/MountListView/MountListView";
import ViewCatalogueSwitchBar from "../../components/ViewCatalogueSwitchBar/ViewCatalogueSwitchBar";
import getBaseUrl from "../../utils/getBaseUrl";

interface Props {}
const updateMountName = (d: any) => ({
  ...d,
  mountName: `${d.mountName} ${d.reference ? `(${d.reference})` : ""}`,
});

export const getCategoryData = (
  currentCategory: string,
  data: any
): Array<Mount> => {
  if (currentCategory) {
    const mountSpecificFamily = data.find(
      (d: any) => d.familyName === currentCategory
    );

    if (mountSpecificFamily) {
      return mountSpecificFamily.mountList.map(updateMountName);
    }

    return [];
  }
  return Array.isArray(data)
    ? data
        .map((d: any) => d.mountList)
        .reduce((acc: Array<any>, cur: Array<any>) => [...acc, ...cur], [])
        .map(updateMountName)
    : [];
};
const Catalogue: React.FC<Props> = () => {
  const ctx = useContext(GlobalContext);
  const { isLoading, error, data } = useQuery(
    ["viewCatalogueData", ctx.failSafe],
    async () => {
      try {
        const url = `${getBaseUrl()}catalogueController/getMountList/${
          ctx.failSafe
        }`;
        const response = await axios.get(url);
        return response.data;
      } catch (err) {
        throw new Error("Somthing went wrong");
      }
    }
  );
  const location = useLocation();
  useEffect(() => {
    if (!window.location.hash.includes("?")) {
      setTimeout(() => {
        ctx.updateGlobalCtx({
          ...ctx,
          currentView: "GRID",
          currentCategory: "",
        });
      }, 0);
    }
  }, [location]);
  const updatorFunction = (obj: any) => {
    ctx.updateGlobalCtx({
      ...ctx,
      ...obj,
    });
  };
  return (
    <section className="container px-3 py-3  md:px-4 md:py-3 lg:px-5 lg:py-3">
      <ViewCatalogueSwitchBar
        currentCategory={ctx.currentCategory}
        value={ctx.failSafe}
        view={ctx.currentView}
        updateData={updatorFunction}
      />
      {isLoading ? (
        <div className="custom-grid">
          <Loader />
        </div>
      ) : (
        <>
          {ctx.currentView === "GRID" && (
            <MountCategories
              categoryDatas={data}
              updateData={updatorFunction}
              failSafe={ctx.failSafe}
            />
          )}
          {ctx.currentView === "LIST" && (
            <MountListView
              values={getCategoryData(ctx.currentCategory, data)}
              columns={[
                { label: "MOUNT_NAME", value: "mountName", sortable: true },
                { label: "PART_NO", value: "partNumber", sortable: true },
                {
                  label: "MIN_LOAD_KG",
                  value: "minStaticLoadKg",
                  sortable: true,
                },
                {
                  label: "MAX_LOAD_KG",
                  value: "maxStaticLoadKg",
                  sortable: true,
                },
                {
                  label: "HARDNESS_WITH_UNIT",
                  value: "hardnessValue",
                  sortable: true,
                },
                { label: "DRAW_NO", value: "drawingNum", sortable: true },
              ]}
              currentCategory={ctx.currentCategory}
              failSafe={ctx.failSafe}
            />
          )}
        </>
      )}
    </section>
  );
};

export default Catalogue;
